import { useMutation, useQueryClient } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { throwIfRequestError } from "../../hooks/request-error";

// POST /api/inventory/orders — createOrders(). Body: [{ vendorId, items: [{ itemId,
// quantityOrdered }] }], one group per vendor.
//
// The legacy screen (src/pages/inventory-procurement/index.jsx) called `request()`
// directly and only checked `response.data.success`, which never surfaces a network-
// level failure (see src/v2/hooks/request-error.js — that is the exact bug this hooks
// convention exists to fix). Promoted to a proper mutation on the move.
export default function useCreatePurchaseOrders() {
    const queryClient = useQueryClient();

    return useMutation(
        async (groups) => {
            const result = await request({ url: "inventory/orders", method: "POST", data: groups });
            throwIfRequestError(result);
            const body = result.data;
            if (!body?.success) throw body;
            return body.data;
        },
        {
            onSuccess: () => {
                // A successful order removes the ordered medicines' demand from the next
                // shortages read and shows up in the purchase-orders list.
                queryClient.invalidateQueries(["pharmacy-procurement-shortages"]);
                queryClient.invalidateQueries(["pharmacy-purchase-orders"]);
            },
        }
    );
}
